import React from 'react';
import styles from './EmailPreviewCard.module.css';
import { emailSource } from '../semantic_search.types';
import { FAIcon } from '../../core/components/faIcon';

interface EmailPreviewCardProps {
    email: emailSource;
    onClick?: () => void;
    icon: React.ReactNode;
    isFavorite: boolean;
    onToggleFavorite: () => void;
}

const renderHighlightedText = (text: string | null | undefined) => {
    if (!text) {
        return null;
    }
    const parts = text.split(/(\|\|\|HIGHLIGHT\|\|\||\|\|\|ENDHIGHLIGHT\|\|\|)/g);
    return (
        <>
            {parts.map((part, index) => {
                if (part === '|||HIGHLIGHT|||') {
                    return <strong key={index} style={{ backgroundColor: "yellow" }}>{parts[index + 1]}</strong>;
                }
                if (part === '|||ENDHIGHLIGHT\|\|\|' || (index > 0 && parts[index-1] === '|||HIGHLIGHT|||')) {
                    return null;
                }
                return part;
            })}
        </>
    );
};

export const EmailPreviewCard: React.FC<EmailPreviewCardProps> = ({ email, onClick, icon, isFavorite, onToggleFavorite }) => {

    const handleFavoriteClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        onToggleFavorite();
    };

    const textParts = email.Text.split('|');
    const senderInfo = textParts[0];
    const bodyText = textParts.slice(1).join('|');


    return (
        <div className={styles.card} onClick={onClick}>
            <header className={styles.header}>
                <div className={styles.titleContainer}>
                    <FAIcon name="envelope" prefix="fal"/>
                    <div className={styles.titleAndMeta}>
                        <div className={styles.title}>{renderHighlightedText(email.Title)}</div>
                        <div className={styles.metaInfo}>
                           {renderHighlightedText(senderInfo)}
                        </div>
                    </div>
                </div>
                <div className={styles.metaIcons}>
                    <div className={styles.iconContainer}>
                        {icon}
                    </div>
                    <button onClick={handleFavoriteClick} className={styles.favoriteButton} title="Als Favorit markieren">
                        <FAIcon name="star" prefix={isFavorite ? 'fas' : 'fal'} />
                    </button>
                </div>
            </header>
            <p className={styles.content}>
                {renderHighlightedText(bodyText)}
            </p>
        </div>
    );
};